export const formatCurrency = (value) => {
  const sanitizedValue = value == null || isNaN(Number(value)) ? 0 : Number(value);
  return sanitizedValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const parseCurrencyToNumber = (formatted) => {
  if (!formatted) return 0;
  const onlyDigits = formatted.replace(/\D/g, '');
  return Number(onlyDigits) / 100;
};

export const formatCompactCurrency = (value) => {
  const abs = Math.abs(value);

  if (abs >= 1e15) return `${(value / 1e15).toFixed(1)}P`;
  if (abs >= 1e12) return `${(value / 1e12).toFixed(1)}T`;
  if (abs >= 1e9) return `${(value / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${(value / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${(value / 1e3).toFixed(0)}k`;
  return `${value}`;
};

export const formatPercentage = (value, decimals = 1) => {
  if (value == null || isNaN(Number(value))) return '0,0%';
  return `${Number(value).toFixed(decimals).replace('.', ',')}%`;
};
